/* eslint-disable mobx/missing-observer */
import type { ComponentPropsWithoutRef } from 'react';

import styles from './CommentsPane.module.scss';

function getClassName(className: string | undefined, moduleClassName: string) {
  return [moduleClassName, className].filter(Boolean).join(' ');
}

function MarkdownHeading1({ children, className, ...props }: ComponentPropsWithoutRef<'h1'>) {
  return (
    <h1 {...props} className={getClassName(className, styles.Heading1)}>
      {children}
    </h1>
  );
}

function MarkdownHeading2({ children, className, ...props }: ComponentPropsWithoutRef<'h2'>) {
  return (
    <h2 {...props} className={getClassName(className, styles.Heading2)}>
      {children}
    </h2>
  );
}

function MarkdownHeading3({ children, className, ...props }: ComponentPropsWithoutRef<'h3'>) {
  return (
    <h3 {...props} className={getClassName(className, styles.Heading3)}>
      {children}
    </h3>
  );
}

function MarkdownParagraph({ children, className, ...props }: ComponentPropsWithoutRef<'p'>) {
  return (
    <p {...props} className={getClassName(className, styles.Paragraph)}>
      {children}
    </p>
  );
}

function MarkdownStrong({ children, className, ...props }: ComponentPropsWithoutRef<'strong'>) {
  return (
    <strong {...props} className={getClassName(className, styles.Strong)}>
      {children}
    </strong>
  );
}

function MarkdownEmphasis({ children, className, ...props }: ComponentPropsWithoutRef<'em'>) {
  return (
    <em {...props} className={getClassName(className, styles.Emphasis)}>
      {children}
    </em>
  );
}

function MarkdownDeleted({ children, className, ...props }: ComponentPropsWithoutRef<'del'>) {
  return (
    <del {...props} className={getClassName(className, styles.Deleted)}>
      {children}
    </del>
  );
}

function MarkdownCode({ children, className, ...props }: ComponentPropsWithoutRef<'code'>) {
  return (
    <code {...props} className={getClassName(className, styles.InlineCode)}>
      {children}
    </code>
  );
}

function MarkdownPre({ children, className, ...props }: ComponentPropsWithoutRef<'pre'>) {
  return (
    <pre {...props} className={getClassName(className, styles.CodeBlock)}>
      {children}
    </pre>
  );
}

function MarkdownTable({ children, ...props }: ComponentPropsWithoutRef<'table'>) {
  return (
    <div className={styles.TableWrapper}>
      <table {...props}>{children}</table>
    </div>
  );
}

function MarkdownBlockquote({ children, className, ...props }: ComponentPropsWithoutRef<'blockquote'>) {
  return (
    <blockquote {...props} className={getClassName(className, styles.Blockquote)}>
      {children}
    </blockquote>
  );
}

function MarkdownUnorderedList({ children, className, ...props }: ComponentPropsWithoutRef<'ul'>) {
  return (
    <ul {...props} className={getClassName(className, styles.UnorderedList)}>
      {children}
    </ul>
  );
}

function MarkdownOrderedList({ children, className, ...props }: ComponentPropsWithoutRef<'ol'>) {
  return (
    <ol {...props} className={getClassName(className, styles.OrderedList)}>
      {children}
    </ol>
  );
}

function MarkdownListItem({ children, className, ...props }: ComponentPropsWithoutRef<'li'>) {
  return (
    <li {...props} className={getClassName(className, styles.ListItem)}>
      {children}
    </li>
  );
}

export const markdownComponents = {
  blockquote: MarkdownBlockquote,
  code: MarkdownCode,
  del: MarkdownDeleted,
  em: MarkdownEmphasis,
  h1: MarkdownHeading1,
  h2: MarkdownHeading2,
  h3: MarkdownHeading3,
  li: MarkdownListItem,
  ol: MarkdownOrderedList,
  p: MarkdownParagraph,
  pre: MarkdownPre,
  strong: MarkdownStrong,
  table: MarkdownTable,
  ul: MarkdownUnorderedList,
};
